<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10LVMfp/tc-custom/9781452123868.jpg?1737751216540" alt="This image is the cover for the book What's for Dinner?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What's for Dinner?
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed author of <i>Big Book of Casseroles</i> delivers another kitchen classic with this volume of two hundred all-purpose, can’t-miss dinner recipes.</b><br/><br/>Trust Maryana Vollstedt to come up with simple, honest food that real people want to eat for dinner. This indispensable cookbook is filled with everyday dishes that are perfect for busy cooks who expect great results with a minimum of time and effort. <br/><br/>Easy to follow and healthy, these recipes offer plenty of tips for menu planning and call for ingredients that are readily available and affordable. And with tempting options like fiery Shrimp Salsa, Herbed Pork Loin with Roasted Potatoes, and Spiced Apple Crisp, <i>What’s for Dinner?</i> is a true kitchen classic.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maryana Vollstedt
      </h2>
      
      <p class="authorDescription body article">Maryana Vollstedt is the author of more than a dozen cookbooks, including The Big Book of Soups & Stews , The Big Book of Casseroles , What s for Dinner? , and Pacific Fresh . She lives in Eugene, Oregon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?417961d3